<template>
  <div class="search-history">
    <div class="search-history__head">
      <span class="search-history__name">История</span>
      <button class="search-history__clear" @click.stop="onClickClear">
        Очистить
      </button>
    </div>
    <search-history-item
      v-for="(item, ind) in lastThreeItems"
      :key="`item-history-${ind}`"
      :name="item.value"
      @setValue="onClickItem"
      @deleteValue="onClickDeleteItem"
    />
  </div>
</template>

<script>
import SearchHistoryItem from './SearchHistoryItem.vue';

export default {
  name: 'search-history',

  components: {
    SearchHistoryItem,
  },

  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    lastThreeItems() {
      return this.items.slice(-3);
    },
  },

  methods: {
    onClickClear() {
      localStorage.removeItem('search-history');
      this.$emit('clearHistory');
    },

    onClickItem(value) {
      this.$emit('setItem', value);
    },

    onClickDeleteItem(value) {
      this.$emit('deleteItem', value);
    },
  },

};
</script>

<style lang="scss" scoped>
.search-history {
  &__head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 4px;
    padding: 4px 0;
  }

  &__name {
    font-weight: 700;
    font-size: 16px;
    line-height: 18px;
    color: #333332;
  }

  &__clear {
    background-color: transparent;
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
    color: #aaa;

    &:hover,
    &:active,
    &:focus-visible {
      color: #333332;
    }
  }
}
</style>
